import React, { useEffect, useState } from 'react';
import { Card, Space, Collapse, Spin, Button, notification } from 'antd';
import { ArrowLeftOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useParams, Link } from 'react-router-dom';
import { getApiDocs, updatePrivacyApiDocs } from '../../apis/apiDocs';
import { getServiceDetail, updateServicePrivacy } from '../../apis/services';
import { formatServerDate } from '../../utils/date';
import HomePageLayout from '../Layout/HomePageLayout';
import MethodTag from '../Method';
import { useHistory } from 'react-router-dom';
import { openErrorNotification } from '../../utils/notification'

const { Panel } = Collapse;

const ServiceEntryDetail = () => {

  const [serviceDetail, setDetail] = useState({});
  const [docList, setDocList] = useState([]);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const history = useHistory();

  if (!id) {
    history.push('/not-found')
  }

  const fetchApiDocs = async (id) => {
    try {
      const docListRes = await getApiDocs(id);
      setDocList(docListRes);
    } catch (error) {
      openErrorNotification('Our system can not fetch data! Please try again')
      console.log(error);
    }
  }

  useEffect(() => {
    const fetchServiceDetail = async () => {
      try {
        if (id ?? false) {
          setLoading(true);
          const servieDetailRes = await getServiceDetail(id);
          console.log('servieDetailRes',servieDetailRes)
          await fetchApiDocs(id);
          setDetail(servieDetailRes);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        openErrorNotification('Our system can not fetch data! Please try again')
        console.log(error);
      }
    }
    fetchServiceDetail();
  }, [id]);

  const updateScope = async (nextValue, group, targetId) => {
    try {
      setLoading(true);

      if (group === 'service-entries') {
        const resp = await updateServicePrivacy(id, {
          public: nextValue
        });
        await fetchApiDocs(id);
        setDetail({
          ...serviceDetail,
          ...resp,
        })
      } else if (group === 'api-docs') {
        await updatePrivacyApiDocs(targetId, {
          public: nextValue,
        });
        const nextDocList = docList.map((doc) => {
          if (parseInt(doc.id) === parseInt(targetId)) {
            return {
              ...doc,
              public: nextValue,
            }
          }
          return doc;
        });
        setDocList(nextDocList);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  return (
    <HomePageLayout>
      <Spin spinning={loading}>
        <div>
          <Button type="primary" size="large">
            <Link to="/"><ArrowLeftOutlined /> Back</Link>
          </Button>
        </div>
        <br></br>
        <div>
          {
            serviceDetail?.name &&
            (<div>
              <Card title={serviceDetail.name}>
                <div>
                  <Space>
                    <p>Description:</p>
                    <p>
                      {serviceDetail.description}
                    </p>
                  </Space>
                </div>
                <div>
                  <Space>
                    <p>Updated At:</p>
                    <p>
                      {serviceDetail.updated ? formatServerDate(serviceDetail.updated / 1000  ) : ''}
                    </p>
                  </Space>
                </div>
              </Card>
            </div>)
          }
        </div>
        <Card title="All Api Docs">
          <Collapse>
            {
              docList.map((doc, index) => {
                return (
                  <Panel header={doc.name} key={index}>
                    <div>
                      <Space>
                        <p>Description:</p>
                        <p>
                          {doc.title}
                        </p>
                      </Space>
                    </div>
                    <div>
                      <Space>
                        <Button type="primary">
                          <Link to={`/api-docs/${doc.id}`}>Detail</Link>
                        </Button>
                      </Space>
                    </div>
                  </Panel>
                )
              })
            }
          </Collapse>
        </Card>
      </Spin>
    </HomePageLayout>
  )
}

export default ServiceEntryDetail;